import { render, staticRenderFns } from "./SpeechRecognition.vue?vue&type=template&id=6094f207&scoped=true"
import script from "./SpeechRecognition.vue?vue&type=script&lang=js"
export * from "./SpeechRecognition.vue?vue&type=script&lang=js"
import style0 from "./SpeechRecognition.vue?vue&type=style&index=0&id=6094f207&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6094f207",
  null
  
)

export default component.exports